import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { valuationGlobalId } from '../state/openValuation';
import { ModalHeader } from './ModalHeader';
import { EditRecentValuationForm } from '../Forms/EditRecentValuationForm';
import { FileUploader } from '../common/FileUploader';

enum Tab {
  Specification,
  Attachments,
}

interface Props {
  onRequestClose(): void;
}

export const OpenValuationModal = (props: Props) => {
  const [tab, setTab] = useState<Tab>(Tab.Specification);
  const [valuationId, setValuationId] = useRecoilState(valuationGlobalId);

  if (!valuationId) return <div></div>;

  return (
    <div>
      <ModalHeader
        onRequestClose={props.onRequestClose}
        header={`Edit Valuation`}
      />

      <div className='row'>
        <ul className='nav nav-tabs'>
          <li className='nav-item'>
            <a
              className={
                tab === Tab.Specification ? 'nav-link active' : 'nav-link'
              }
              onClick={(e) => {
                setTab(Tab.Specification);
              }}
              href='#'
            >
              Specification
            </a>
          </li>
          <li className='nav-item'>
            <a
              className={
                tab === Tab.Attachments ? 'nav-link active' : 'nav-link'
              }
              onClick={(e) => {
                setTab(Tab.Attachments);
              }}
              href='#'
            >
              Attachments
            </a>
          </li>
        </ul>
      </div>

      {tab === Tab.Specification && (
        <EditRecentValuationForm onRequestClose={props.onRequestClose} />
      )}
      {tab === Tab.Attachments && (
        <FileUploader
          entityId={valuationId}
          entityTag={'valuation'}
          onRequestClose={props.onRequestClose}
        />
      )}
    </div>
  );
};
